import { Button, Form, Input, Modal } from 'antd';
import React,{useState,useEffect} from 'react';
import {Link} from 'react-router-dom';
import LoginPopConfirm from '../../common/LoginPopConfirm';
import { getCookie, isEmail,requestMainUrl,getControlsBar,urlPrefix,imgUrlSite,getSessionItem } from '../../common/service/common';
import { messageTips } from '../../common/service/Tools';
import BraftEditor from 'braft-editor';
import 'braft-editor/dist/index.css';

function Index() {
    const [hotList, sethotList] = useState([]);
    const [cates, setcates] = useState();
    const [currentCate, setcurrentCate] = useState(1);
    const [commonQues, setcommonQues] = useState([]);
    const [visible, setvisible] = useState(false);

    const [realName, setrealName] = useState('');
    const [email, setemail] = useState('');
    const [groupName, setgroupName] = useState('');
    const [content, setcontent] = useState(BraftEditor.createEditorState(''));
    const [specialCate, setspecialCate] = useState({});
    const icon_names = [        
        'EPS-user',
        'EPS-edit-people',
        'EPS-book4',
        'EPS-people111',
        'EPS-bianji11',
        'EPS-chat',
        'EPS-other111'
    ];

    useEffect(() => {
        React.$http.admin_get_help_cate().then(res=>{
            if(res&&res.classifyEntities) {
                setcates(res.classifyEntities.slice(0,6));
                let end = res.classifyEntities.slice(-1);
                setspecialCate(end[0]);
                changeCate(end[0]);
            }
        });
        React.$http.get_hot_help().then(res=>{
            if(res&&res.helpEntities) {
                sethotList(res.helpEntities);
            }
        })
    }, []);

    const changeCate=(item)=>{
        setcurrentCate(item.classifyCode);
        getCommonQues(item.classifyCode)
    }

    const handleCancel=()=>{
        setvisible(false);
        setrealName('');
        setemail('');
        setgroupName('');
        setcontent(BraftEditor.createEditorState(''));
    }

    const getCommonQues=(classify)=>{
        React.$http.admin_get_help_list({classify}).then(res=>{
            if(res&&res.helpEntities) {
                setcommonQues(res.helpEntities);
            }
        });
    }

    const controls = getControlsBar(content,(e)=>{setcontent(e)});
    const uploadFn = (param) => {
        let sid = getCookie('z_sid');    
        let user = getSessionItem('userInfo');
        const serverURL = requestMainUrl+urlPrefix[3]+'question/uploadQuestionImage?sid='+sid+'&userId='+user.userId;//upload 是接口地址
        const xhr = new XMLHttpRequest();
        const fd = new FormData();
        const successFn = (response) => {
            const upLoadObject = JSON.parse(response && response.currentTarget && response.currentTarget.response);
            if(upLoadObject&&upLoadObject.success){
                param.success({
                    url: imgUrlSite+JSON.parse(xhr.responseText).url,
                    meta: {
                        id: upLoadObject && upLoadObject.id,
                        title: upLoadObject && upLoadObject.fileName,
                        alt: upLoadObject && upLoadObject.fileName,
                        loop: false,
                        autoPlay: false,
                        controls: false,
                        poster: '',
                    }
                })
            }else{
                messageTips(upLoadObject.message,1);
                return;
            }
        };

        const progressFn = (event) => {
            param.progress(event.loaded / event.total * 100)

        };

        const errorFn = (response) => {
            param.error({
                msg: 'unable to upload.'
            })
        };
        if(param.file.size / 1024 / 1024 > 5){
            messageTips('图片过大，请重新上传',1);
            return;
        }
        xhr.upload.addEventListener("progress", progressFn, false);
        xhr.addEventListener("load", successFn, false);
        xhr.addEventListener("error", errorFn, false);
        xhr.addEventListener("abort", errorFn, false);

        fd.append('file', param.file);
        xhr.open('POST', serverURL, true);
        xhr.setRequestHeader("X-Auth-Token", '');
        xhr.send(fd)
    }

    const handleEditorChange = (editorState) => {
        setcontent(editorState);
    }

    const submitReback=(e)=>{
        e.preventDefault();
        if(!realName) {
            messageTips('请输入您的姓名',2);
            return false;
        }
        if(!email) {
            messageTips('请输入您的邮箱',2);
            return false;
        }
        if(!isEmail(email)) {
            messageTips('邮箱格式不正确',2);
            return false;
        }
        if(!groupName) {
            messageTips('请输入您的机构名称',2);
            return false;
        }
        if(!content) {
            messageTips('请输入反馈内容',2);
            return false;
        }
        if(content.length<10) {
            messageTips('请输入不少于10个字的反馈内容',2);
            return false;
        }
        let params = {
            realName,
            email,
            groupName,
            content:content.toHTML()
        }
        React.$http.helper_reback(params).then(res=>{
            if(res&&res.status) {
                handleCancel();
                messageTips('反馈成功，请耐心等待回复。注意查收邮件',3,5);
            }
        });
    }

    const sid = getCookie('z_sid');

    return (
        <div className="mainWrap ">
            <div className="helper-index">
                <div className="hot-ques">
                    <h2><span className="color-block"></span>热门问题</h2>
                    <div className="list">
                        {
                            hotList?hotList.map((item,key)=>{
                                return <div className="item" key={key}>
                                    <Link to={'/detail/'+item.helpId}>
                                        <span className="color-block"></span>{item.title}
                                    </Link>
                                </div>
                            }):''
                        }
                    </div>
                </div>

                <div className="use-chanel">
                    <div className="item">
                        <div className="ico-wrap ico-wrap1">
                            <span className="ico-helper ico1"></span>
                        </div>
                        <div className="desc">对产品改进有任何意见与建议</div>
                        {
                            sid?<span  onClick={()=>{setvisible(true)}}>我要反馈&gt;</span>:(
                                <LoginPopConfirm
                                    button={<span>我要反馈&gt;</span>}
                                />
                            )
                        }
                        
                    </div>

                    <div className="item">
                        <div className="ico-wrap ico-wrap2">
                            <span className="ico-helper ico2"></span>

                        </div>
                        <div className="desc">产品使用过程中有任何问题请联系人工客服</div>
                        <a href="http://chat10.live800.com/live800/chatClient/chatbox.jsp?companyID=448316&jid=6318557147&enterurl=http%3A%2F%2Fwww%2Eepsnet%2Ecom%2Ecn%2Fch%2FSys%2FReportPage%2Easpx%3FKey%3D230%26Type%3DKE%5FCLASS%5FEXPRESSREPORT&timestamp=1344843114447&pagereferrer=" target="_blank" rel="noopener noreferrer">在线客服&gt;</a>
                    </div>
                    

                    <div className="item">
                        <div className="ico-wrap ico-wrap3">
                            <span className="ico-helper ico3"></span>
                        </div>
                        <div className="desc">机构用户申请开通产品试用</div>
                        <a href="https://www.epsnet.com.cn/index.html#/About?type=6" target="_blank" rel="noopener noreferrer">联系我们&gt;</a>
                    </div>
                </div>
                <div className="clear"></div>

                <div className="common-ques">
                    <h2><span className="color-block"></span>如何玩转知图</h2>
                    <div className="cates">
                        <div className={currentCate===specialCate.classifyCode?'active item':'item'} onClick={()=>{changeCate(specialCate)}}>
                            <div className={'ico-helper-wrap'}>
                                <div className={'icon-helper '+icon_names[0]}></div>
                            </div>
                            <div className="name">{specialCate.classifyName}</div>
                        </div>
                        {
                            cates?cates.map((item,key)=>{
                                return <div className={currentCate===item.classifyCode?'active item':'item'} key={key} onClick={()=>{changeCate(item)}}>
                                    <div className={'ico-helper-wrap'}>
                                        <div className={'icon-helper '+icon_names[key+1]}></div>
                                    </div>
                                    <div className="name">{item.classifyName}</div>
                                </div>
                            }):''
                        }
                        <div className="clear"></div>
                    </div>
                    <div className="splite-line">
                        <div className="triangle"></div>
                        <div className="triangle2"></div>
                    </div>

                    <div className="list">
                        {
                            commonQues.map((item,key)=>{
                                return <div className="item" key={key}>
                                    <Link to={'/detail/'+item.helpId}>
                                        <span className="color-block"></span>{item.title}
                                    </Link>
                                </div>
                            })
                        }
                        <div className="clear"></div>
                    </div>
                </div>
            </div>


            <Modal
            title="意见反馈"
            visible={visible}
            onCancel={handleCancel}
            centered
            width={850}
            zIndex={1}
            footer={null}
            wrapClassName="reback-win"
            >
                <Form onSubmit={submitReback}>
                    <div className="form-item">
                        <div className="label">您的姓名</div>
                        <Input value={realName} onChange={e=>{setrealName(e.target.value.substring(0,20))}} />
                    </div>
                    <div className="form-item">
                        <div className="label">您的邮箱</div>
                        <Input value={email} onChange={e=>{setemail(e.target.value)}} />
                    </div>
                    <div className="form-item">
                        <div className="label">您所在的机构</div>
                        <Input value={groupName} onChange={e=>{setgroupName(e.target.value)}} />
                    </div>
                    <div className="form-item">
                        <div className="label">反馈内容（不少于10个字）</div>
                        <BraftEditor
                                className="my-editor"
                                style={{border:'1px solid #ccc',height:300}}
                                placeholder="请输入正文内容"
                                onChange={handleEditorChange}
                                value={content}                            
                                controls={controls}
                                textAligns={['left','center','right']}
                                media={{ 
                                    uploadFn: uploadFn,
                                    accepts:{
                                        image: 'image/png,image/jpeg,image/gif,image/webp,image/apng,image/svg',
                                        video: '',
                                        audio: ''
                                    } 
                                }}
                                />
                    </div>

                    <div className="btns">
                        <Button type="primary" ghost className="cancel" onClick={handleCancel}>取消</Button>
                        <Button type="primary" htmlType="submit">确定</Button>
                    </div>
                </Form>
            </Modal>
        </div>
    )
}

export default Index;
